<form
  [formGroup]="form"
  NFFormValidation
  (validSubmit)="onSubmit()"
  id="find-bulk-transactions-form"
>
  <nf-form-control label="Root Ids" compact>
    <nf-radio-group [formControl]="rootIdType">
      <nf-radio-button
        label="Account IDs"
        value="accountIds"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Ultimate Parent IDs"
        value="ultimateParentIds"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Client IDs"
        value="clientIds"
        [inline]="true"
      ></nf-radio-button>
    </nf-radio-group>
    <input
      type="text"
      class="form-control"
      [formControl]="rootIdsFilterControl"
    />
  </nf-form-control>
  <nf-form-control label="Security" [customErrorMessages]="errors" compact>
    <nf-radio-group [formControl]="searchIdType">
      <nf-radio-button
        label="Asset IDs"
        value="assetIds"
        [inline]="true"
      ></nf-radio-button>
      <nf-radio-button
        label="Security IDs"
        value="securityIds"
        [inline]="true"
      ></nf-radio-button>
    </nf-radio-group>
    <input
      type="text"
      class="form-control"
      [formControl]="searchByIdFilterControl"
    />
    <div
      *ngIf="searchByIdFilterControl.errors?.invalidNumber"
      class="invalid-feedback"
    >
      Invalid input. Please enter a number or a list of numbers.
    </div>
    <div
      *ngIf="searchByIdFilterControl.errors?.invalidString"
      class="invalid-feedback"
    >
      Invalid input. Please enter a valid input.
    </div>
  </nf-form-control>
  <hr />
  <nf-form-control label="Break status" compact>
    <ng-select
      [formControl]="breakStatusFilterControl"
      [items]="statusTypes"
      [multiple]="true"
      class="multi-select"
      placeholder="Select Break Status"
      clearAllText="Clear"
      [clearable]="true"
      [clearOnBackspace]="true"
      [closeOnSelect]="false"
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div
          *ngIf="items.length > 1; else singleItem"
          class="ng-value nf-custom-badge"
        >
          <span class="ng-value-label">
            {{ items.length }} statuses selected
          </span>
        </div>
        <ng-template #singleItem>
          <div class="ng-value nf-custom-badge">
            <span class="ng-value-label">{{ items }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>
  </nf-form-control>
  <nf-form-control label="Break type" compact>
    <ng-select
      [formControl]="breakTypesFilterControl"
      [items]="breakType"
      bindLabel="displayName"
      [multiple]="true"
      class="multi-select"
      placeholder="Select Break Type"
      clearAllText="Clear"
      [clearable]="true"
      [clearOnBackspace]="true"
      [closeOnSelect]="false"
      groupBy="selectedAllGroup"
      [selectableGroup]="true"
      [selectableGroupAsModel]="false"
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div
          *ngIf="items.length > 1; else singleItem"
          class="ng-value nf-custom-badge"
        >
          <span class="ng-value-label">
            {{ items.length }} types selected
          </span>
        </div>
        <ng-template #singleItem>
          <div class="ng-value nf-custom-badge">
            <span class="ng-value-label">{{ items[0].displayName }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template
        ng-optgroup-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        <input
          id="item-{{ index }}"
          type="checkbox"
          [checked]="item$.selected"
        />
        Select All
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        <input
          id="item-{{ index }}"
          type="checkbox"
          [checked]="item$.selected"
        />
        {{ item.displayName }}
      </ng-template>
    </ng-select>
  </nf-form-control>
  <nf-form-control label="Break priority" compact>
    <ng-select
      [formControl]="breakPriorityFilterControl"
      [items]="priorityTypes"
      [multiple]="true"
      class="multi-select"
      placeholder="Select Break Priority"
      clearAllText="Clear"
      [clearable]="true"
      [clearOnBackspace]="true"
      [closeOnSelect]="false"
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div
          *ngIf="items.length > 1; else singleItem"
          class="ng-value nf-custom-badge"
        >
          <span class="ng-value-label">
            {{ items.length }} priorities selected
          </span>
        </div>
        <ng-template #singleItem>
          <div class="ng-value nf-custom-badge">
            <span class="ng-value-label">{{ items }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div container="body" class="ellipsis">
          {{ item }}
        </div>
      </ng-template>
    </ng-select>
  </nf-form-control>

  <nf-form-control label="Break category" compact>
    <ng-select
      [formControl]="breakCategoriesFilterControl"
      [items]="breakCategories"
      [multiple]="true"
      class="multi-select"
      placeholder="Select Break Category"
      clearAllText="Clear"
      [clearable]="true"
      [clearOnBackspace]="true"
      [closeOnSelect]="false"
      groupBy="selectedAllGroup"
      [selectableGroup]="true"
      [selectableGroupAsModel]="false"
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div
          *ngIf="items.length > 1; else singleItem"
          class="ng-value nf-custom-badge"
        >
          <span class="ng-value-label">
            {{ items.length }} categories selected
          </span>
        </div>
        <ng-template #singleItem>
          <div class="ng-value nf-custom-badge">
            <span class="ng-value-label">{{ items[0].name }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template
        ng-optgroup-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        <input
          id="item-{{ index }}"
          type="checkbox"
          [checked]="item$.selected"
        />
        Select All
      </ng-template>
      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        <input
          id="item-{{ index }}"
          type="checkbox"
          [checked]="item$.selected"
        />
        {{ item.name }}
      </ng-template>
    </ng-select>
  </nf-form-control>
  <div *ngIf="areInputsEmpty$ | async">
    <div class="small ml-1" id="atLeastOneError">
      *At least one Root Id or Security is required.
    </div>
  </div>
  <button
    nf-button="submit"
    (click)="onSubmit(true)"
    [loading]="isFormSubmitting"
    [disabled]="applyDisabled || !form.valid"
  >
    Apply
  </button>
</form>
